import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CompanyHistory from "./pageComponents/History";
import MamuriatSazmani from "./pageComponents/MamuriatSazmani";
import CheshmAndaz from "./pageComponents/CheshmAndaz";
import ArzeshhayeSazmani from "./pageComponents/ArzeshhayeSazmani";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component={"span"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{
        flexGrow: 1,
      }}
    >
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label=""
          variant="scrollable"
          scrollButtons
        >
          <Tab label="تاریخچه شرکت" {...a11yProps(0)} />
          <Tab label="ماموریت سازمانی" {...a11yProps(1)} />
          <Tab label="چشم انداز" {...a11yProps(2)} />
          <Tab label="ارزشهای سازمانی" {...a11yProps(3)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <CompanyHistory />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <MamuriatSazmani />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <CheshmAndaz />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <ArzeshhayeSazmani />
      </TabPanel>
    </Box>
  );
}
